import type { FC } from 'react';
import { Inline } from '@george-labs.com/design-system';

import { formatDate } from '@luna/date';

import { HighlightCard } from '../components/HighlightCard';

type HighlightCardProps = Omit<Parameters<typeof HighlightCard>[0], 'value'>;

type Props = HighlightCardProps & {
    date: string;
};

export const DateHighlight: FC<Props> = ({
    icon,
    label,
    date,
    'data-cy': dataCy,
    valuePostfix,
    children,
    illustration,
}) => (
    <HighlightCard
        data-cy={dataCy}
        icon={icon}
        illustration={illustration}
        label={label}
        valuePostfix={valuePostfix}
        value={
            <Inline emphasis data-cy={`${dataCy}-highlight-date`}>
                {formatDate(date)}
            </Inline>
        }
    >
        {children}
    </HighlightCard>
);
